<template>

  <div v-if="initComplete" class="detail_root site_content">

    <!-- 面包屑 -->
    <div class="breadcrumb_w">
      <SiteBreadcrumb />
    </div>

    <div class="top_box">
      <el-card class="box-card">
        <div class="content-wrapper">
          <div class="picture_w">
            <el-image
              class="picture"
              :src="
                itemDetail.cover
                  ? itemDetail.cover + '!283'
                  : require('@/assets/images/huayuan.png')
              "
              alt=""
              lazy
            />
          </div>
          <div class="context_main">
            <div class="service_context_name">
              <span>{{ itemDetail.name }}</span>
            </div>
            <div class="service_context_deil">
              <div class="width2">
                <span>成立时间：{{ itemDetail.formed }}</span>
              </div>
              <div class="width1">
                <span>联系人：{{ itemDetail.contact }}</span>
              </div>
              <div class="width2">
                <span>联系电话：{{ itemDetail.contactPhone }}</span>
              </div>
              <div class="width3">
                <el-tooltip class="item" effect="dark" :content="itemDetail.address" placement="bottom">
                  <span>联系地址：{{ itemDetail.address }}</span>
                </el-tooltip>
              </div>

            </div>
          </div>
        </div>
      </el-card>
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-postcard" /> 企业简介</span>
          <div class="show">
            <p v-html="itemDetail.about" />
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i
            class="el-icon-s-cooperation"
          /> 主营业务</span>
          <div class="show">
            <p v-html="itemDetail.mainBusiness" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import SiteBreadcrumb from '@/components/base/SiteBreadcrumb.vue'

import { portal_facilitator_info } from '@/api/portal'

export default {
  components: {
    SiteBreadcrumb
  },
  data() {
    return {
      itemDetail: null, // 项目详情数据
      initComplete: false
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  created() {
    this.getItemDetail()
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    // 获取服务商详情
    async getItemDetail() {
      const { data } = await portal_facilitator_info({
        id: this.id
      })

      this.itemDetail = JSON.parse(JSON.stringify(data))
      console.log('itemDetail', this.itemDetail)
      this.initComplete = true
    }
  }
}
</script>

<style lang="scss" scoped>

  .detail_root{
    margin: 0 auto 20px auto;
    padding-top: 9px;
  }
  .top_box{
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px 20px;
  }
  .main_box{
    display: flex;
    justify-content: space-between;
    .main_l{
      background-color: #fff;
    }
  }
  .full-container {
  width: 100%;
  height: 100vh; /* 视口高度 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.box-card {
  width: 100%;
  height: 150px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  height: 107px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative; /* 为了竖线定位 */
}

.picture_w{
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中 */
  width: 157px;
  height: 107px;
}

.item {
  width: calc(50% - 1px); /* 减去竖线的宽度 */
  padding: 10px; /* 根据需要调整 */
  box-sizing: border-box;
}

.service_context_name{
  font-weight: bold;
  font-size: 23px;
  margin-top: 18px;
}

.service_context_deil{
  display: flex;
  margin-top: 35px;
  font-size: 13px;
  .width1{
    width: 140px;
    white-space: nowrap; /* 文本不换行 */
    overflow: hidden; /* 隐藏溢出部分的文本 */
    text-overflow: ellipsis; /* 显示省略号 */
  }
  .width2{
    width: 200px;
  }
  .width3{
    width: 370px;
    white-space: nowrap; /* 文本不换行 */
    overflow: hidden; /* 隐藏溢出部分的文本 */
    text-overflow: ellipsis; /* 显示省略号 */
  }
}

.show{
  margin:6px 0px 0px 14px;
  p{
    text-indent: 2em;
    line-height: 2;
  }
}

.context_main{
  margin-left: 35px;
}

  ::v-deep .el-tabs--border-card{//修改整体背景色与边框为透明
    min-height: 400px;
		background-color: white;
    border-color: transparent;
		.el-tabs__header {//修改标签背景色为透明，并且没有下边横线
		  background-color: white;
			.el-tabs__nav {//将标签整体轮廓绿色
				.el-tabs__item.is-active{//标签点击时，背景色变为蓝色，字体变为白色，左右上边框变绿色，
					color: #0983CC;
				}
			}

		}
	}
</style>
